<template>
  <v-container class="pt-0" fluid>
    <v-layout justify-center row>
      <v-flex xs10>
        <v-container fluid grid-list-md>
          <v-subheader class="px-0">基本信息</v-subheader>
          <v-layout class="mb-4" row wrap>
            <v-flex xs4>
              <v-text-field
                label="车辆号牌"
                placeholder="N/A"
                :prepend-icon="$vuetify.icons.car"
                readonly
                v-model="vehicleInfo.plateNumber"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="手机号码"
                placeholder="N/A"
                :prepend-icon="$vuetify.icons.phone"
                readonly
                v-model="vehicleInfo.phone"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="车主姓名"
                placeholder="N/A"
                :prepend-icon="$vuetify.icons.person"
                readonly
                v-model="vehicleInfo.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="用户账号"
                placeholder="N/A"
                prepend-icon="mdi-clipboard-account"
                readonly
                v-model="vehicleInfo.loginId"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="车辆登记类型"
                placeholder="N/A"
                prepend-icon="mdi-account-card-details"
                readonly
                v-model="vehicleInfo.vehicleType"
              ></v-text-field>
            </v-flex>
            <v-flex xs4>
              <v-text-field
                label="用户登记类型"
                placeholder="N/A"
                :prepend-icon="$vuetify.icons.group"
                readonly
                v-model="vehicleInfo.userType"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-subheader class="px-0">车辆登记图片</v-subheader>
          <v-layout class="px-3 pb-3" wrap>
            <v-flex>
              <template v-for="(img,i) in vehicleInfo.imgItems">
                <l-image-view-dialog :key="i" :src="img.src">
                  <v-subheader slot="activator" class="px-0">
                    {{img.label}}
                  </v-subheader>
                  <l-image-placeholder
                    slot="activator"
                    style="float:left;cursor: pointer"
                    :src="img.src"
                    :error="!!img.error"
                    :error-message="img.error"
                    :loading="!!img.loading"
                  ></l-image-placeholder>
                </l-image-view-dialog>
              </template>
              <template v-if="vehicleInfo.imgItems.length === 0">
                <l-image-placeholder></l-image-placeholder>
              </template>
            </v-flex>
          </v-layout>
          <v-layout justify-center v-if="status==='review'">
            <v-btn class="error" @click="submitConfirm('false')" :loading="loading" >拒绝</v-btn>
            <v-btn class="success" @click="submitConfirm('true')" :loading="loading">通过</v-btn>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-dialog
      v-model="reviewConfirm"
      width="500">
      <v-layout column>
        <v-card>
          <v-card-title>
            <h4>确认框</h4>
          </v-card-title>
          <v-card-text>
            <p>您确认{{(currentItem.status==='true')?'通过':'拒绝'}}该车辆审核申请？{{(currentItem.status==='true')?'':'（请填写拒绝理由）'}}</p>
            <v-textarea
              v-if="currentItem.status==='false'"
              v-model="comment"
              label="附言"
              counter="1000"
              :rules="[$rules.requiredS('必填')]"
            >
            </v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-layout justify-center>
              <v-btn class="info" @click="submit(currentItem.status)" :loading="loading">确定</v-btn>
              <v-btn class="error" @click="reviewConfirm=false" >取消</v-btn>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-dialog>
  </v-container>
</template>
<script>
// import {time} from '../../ladmin/utils/time'
import LImagePlaceholder from '../../ladmin/components/LImage/LImagePlaceholder'
import LImageViewDialog from '../../ladmin/components/LImageDialog/LImageViewDialog'
export default{
  name: 'vehicleDetailContent',
  components: {LImageViewDialog, LImagePlaceholder},
  props: {
    formData: {type: Object, default: () => ({})},
    status: {type: String, default: ''}
  },
  data () {
    return {
      vehicleInfo: {
        plateNumber: '',
        name: '',
        phone: '',
        userType: '',
        vehicleType: '',
        loginId: '',
        imgItems: [],
        id: ''
      },
      loading: false,
      reviewConfirm: false,
      currentItem: {status: ''},
      comment: '',
      vehicleType: {
        per_ve: '校内用户车辆',
        coo_ve: '合作用户车辆',
        reservation: '预约车辆',
        org_ve: '校内单位公车'
      }
    }
  },
  created () {
    this.dealFormData(this.formData)
    this.status = this.$route.query.status
  },
  methods: {
    dealFormData (item) {
      let data = item
      this.vehicleInfo.plateNumber = data.vehicle.plateNumber
      this.vehicleInfo.loginId = data.user.loginId
      this.vehicleInfo.name = data.user.name
      this.vehicleInfo.phone = data.vehicle.phone
      this.vehicleInfo.userType = data.user.authType
      this.vehicleInfo.vehicleType = this.vehicleType[data.vehicle.checkType]
      this.vehicleInfo.id = data.vehicle.id
      if (data.vehicle.objectCheckInfo === undefined || data.vehicle.objectCheckInfo === null || data.vehicle.objectCheckInfo === '') {
        return
      }
      let picArray = JSON.parse(data.vehicle.objectCheckInfo).pic
      let driverLicense = {
        label: '驾驶证',
        src: 'https://smaco2.uestc.edu.cn/passApi' + picArray[0].url1
      }
      console.log(picArray)
      if (picArray[0].url1 !== '' && picArray[0].url1 !== undefined) {
        this.vehicleInfo.imgItems.push(driverLicense)
      }
      let vehicleLicense = {
        label: '行驶证',
        src: 'https://smaco2.uestc.edu.cn/passApi' + picArray[1].url2
      }
      if (picArray[1].url2 !== '' && picArray[1].url2 !== undefined) {
        this.vehicleInfo.imgItems.push(vehicleLicense)
      }
      let otherImage = {
        label: '其他证明',
        src: 'https://smaco2.uestc.edu.cn/passApi' + picArray[2].url3
      }
      if (picArray[2].url3 !== '' && picArray[2].url3 !== undefined) {
        this.vehicleInfo.imgItems.push(otherImage)
      }
    },
    submitConfirm (status) {
      this.reviewConfirm = true
      this.currentItem.status = status
    },
    async submit (result) {
      if (result === 'false' && this.comment.length === 0) {
        this.$L.alert('error', {message: '请填写拒绝理由'})
        return
      }
      this.loading = true
      let res = await this.$store.dispatch('vehicleRegister/reviewVehicle', {result: result, id: this.vehicleInfo.id, comment: this.comment})
      this.loading = false
      this.reviewConfirm = false
      if (res.data.status === 1) {
        this.$L.alert('success', {message: '审核完成'})
        this.status = 'readonly'
      }
      else {
        this.$L.alert('error', {message: '审核失败，原因:' + res.data.msg})
      }
    }
  }
}
</script>
